var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96484 6.42833L7.78151 10.3067C8.58401 10.8408 8.98484 11.1083 9.41818 11.2125C9.80151 11.3042 10.2007 11.3042 10.5832 11.2125C11.0165 11.1083 11.4173 10.8408 12.2198 10.3067L18.0365 6.42833M5.96484 16.25H14.0365C15.4365 16.25 16.1365 16.25 16.6715 15.9775C17.1416 15.7377 17.5237 15.3553 17.7632 14.885C18.0365 14.35 18.0365 13.65 18.0365 12.25V7.75C18.0365 6.35 18.0365 5.65 17.764 5.115C17.5243 4.64462 17.1419 4.26218 16.6715 4.0225C16.1365 3.75 15.4365 3.75 14.0365 3.75H5.96484C4.56484 3.75 3.86484 3.75 3.32984 4.0225C2.85977 4.26232 2.47764 4.64474 2.23818 5.115C1.96484 5.65 1.96484 6.35 1.96484 7.75V12.25C1.96484 13.65 1.96484 14.35 2.23734 14.885C2.47702 15.3554 2.85946 15.7378 3.32984 15.9775C3.86484 16.25 4.56484 16.25 5.96484 16.25Z",
    stroke: "#FE5A97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterEmail);
export default __webpack_public_path__ + "static/media/footerEmail.d799f02ec84a7310e0b1d2e76fd4d928.svg";
export { ForwardRef as ReactComponent };